import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, map, sortBy, sum } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import DashboardBar from "../DashboardBar";
import CloseIcon from "../../Common/CloseIcon";

import colors from "../../../assets/style/colors";

const styles = {
  dialogPaper: {
    minWidth: "415px",
    maxWidth: "400px",
    padding: "12px 0px 0px",
  },
  closeIcon: {
    paddingRight: "12px",
    display: "flex",
    justifyContent: "flex-end",
  },
  link: {
    marginLeft: "45px",
    marginTop: "2px",
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  disabledLink: {
    marginLeft: "45px",
    marginTop: "2px",
    color: colors.black54,
  },
  total: {
    color: colors.black38,
    width: "85px",
    borderBottom: `1px solid ${colors.black23}`,
    fontSize: "1.857em",
    marginBottom: "15px",
    fontWeight: 500,
  },
};

const HspTopSymptomsDialog = (props) => {
  const { classes, data, language } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <div
        className={data ? classes.link : classes.disabledLink}
        onClick={() => (data ? setOpen(true) : null)}
      >
        {I18n.get("dashboard_viewAll")}
      </div>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid
                item
                xs
                className="dialogTitle flexCenter"
                style={{ justifyContent: "center" }}
              >
                {I18n.get("dashboard_riskCategories")}
              </Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ paddingLeft: "20px" }}>
            <Grid container direction="column">
              <Grid item className={classes.total}>
                {sum(map(data, (s) => s.total))}
              </Grid>
              <Grid
                item
                style={{
                  maxHeight: "calc(100vh - 190px)",
                  overflow: "auto",
                  paddingRight: "20px",
                  paddingBottom: "20px",
                }}
              >
                {map(
                  sortBy(data, (s) => -s.total),
                  (s, i) => (
                    <Grid item key={i}>
                      <DashboardBar
                        title={get(s, [`category_${language}`])}
                        value={get(s, ["total"])}
                        percentage={get(s, ["percentage"])}
                        colors={[colors.dashboardDarkBlue, colors.greyDoughnut]}
                        style={{
                          marginTop: i > 0 ? "5px" : 0,
                          marginBottom: "15px",
                        }}
                      />
                    </Grid>
                  )
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(HspTopSymptomsDialog);
